export default "__VITE_ASSET__2db46bd0__"